'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash.isboolean');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Check if a value is a boolean value `true` or `false`
 *
 * @name isBoolean
 * @param {*} param The value to check for boolean type
 * @returns {boolean} Returns `true` when the value is a boolean otherwise `false`
 */
exports.default = _lodash2.default;
//# sourceMappingURL=isBoolean.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/~/d2-utilizr/lib/isBoolean.js
 ** module id = 15
 ** module chunks = 0 1
 **/